export default {
  namespaced: true,
  state: {
    lessonHabit: null
  },
  getters: {
    hasSetting: state => {
      return state.lessonHabit && state.lessonHabit.growth_rate && state.lessonHabit.rate < 100
    },
    isAchieved: state => {
      return state.lessonHabit && state.lessonHabit.rate == 100
    }
  },
  mutations: {
    setLessonHabit(state, payload) {
      state.lessonHabit = payload
    }
  }
}
